import Vue from 'vue';
import VueRouter from 'vue-router';
import firebase from 'firebase';

// Component for Auth
import Login from './views/auth/Login';
import Register from './views/auth/Register';
import ResetPassword from './views/auth/ResetPassword';

// Component for User is logged in
import UserIndex from './views/user/Index';
import UserSetting from './views/user/Setting';

Vue.use(VueRouter);

const routes = [
    // Auth
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            auth: false,
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            auth: false,
        }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: ResetPassword,
        meta: {
            auth: false,
        }
    },

    // Account
    {
        path: '/',
        name: 'index',
        component: UserIndex,
        meta: {
            auth: true,
        }
    },
    {
        path: '/setting',
        name: 'setting',
        component: UserSetting,
        meta: {
            auth: true,
        }
    },
]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: process.env.BASE_URL,
});

router.beforeEach((to, from, next) => {
    let currentUser = firebase.auth().currentUser;
    let account = localStorage.getItem('account');
    let auth = to.matched.some(record => record.meta.auth);

    if(auth) {
        if(currentUser && account) {
            next();
        } else {
            next({ path: '/login' });
        }
    } else {
        if(currentUser && account) {
            next({ path: '/' });
        } else {
            next();
        }
    }
})

export default router;